// extracted by mini-css-extract-plugin
export default {"privacyNotice":"tsAndCs_privacyNotice__g21WN"};